import React, { useMemo } from 'react';
import {
  eToNumber,
  formatValue,
  addThousandSeparator,
} from '@bitbot/shared/utils/quote-value';
import clsx from 'clsx';

export const getDecimalFormatValue = (
  value: number | string | undefined | null,
  format = 4,
) => {
  if (value === '' || value === undefined || value === null) return '';
  const str = String(value);
  if (value === 0 || value === 1 || !str.includes('.'))
    return String(value);
  const num = +value;
  if (num >= 1) {
    return formatValue(value, format + 2);
  } else {
    const arr = str.split('.');
    const suffix = arr[1];
    let zeroCounts = 0;
    let appendStr = '';
    for (let i = 0; i < suffix.length; i++) {
      if (i === zeroCounts && suffix[i] === '0') {
        zeroCounts++;
      } else {
        appendStr += suffix[i];
      }
    }
    if (zeroCounts + appendStr.length <= format) {
      return `0.${'0'.repeat(zeroCounts)}${appendStr}`;
    } else {
      return `0.${'0'.repeat(zeroCounts)}${appendStr.substring(
        0,
        format,
      )}`;
    }
  }
};

export default function DecimalFormat({
  value,
  format = 6,
  className,
  isUsd,
  symbol,
  isQuote = true,
}: {
  value: number | string | undefined | null;
  format?: number;
  className?: string;
  isUsd?: boolean;
  symbol?: string | null | undefined;
  isQuote?: boolean;
}) {
  const data = useMemo(() => {
    if (value === '' || value === undefined || value === null) return '';
    const str = eToNumber(+value);
    if (+value === 0) {
      return '0.00';
    }
    if (value === 0 || value === 1 || !str.includes('.')) {
      if (isQuote) {
        return addThousandSeparator(value);
      } else return value;
    }
    const num = +value;
    if (num >= 1) {
      if (isUsd) {
        format = 2;
      }
      if (isQuote) {
        return addThousandSeparator(formatValue(value, format));
      } else {
        return formatValue(value, format);
      }
    } else {
      const arr = str.split('.');
      const suffix = arr[1];
      let zeroCounts = 0;
      let appendStr = '';
      for (let i = 0; i < suffix.length; i++) {
        if (i === zeroCounts && suffix[i] === '0') {
          zeroCounts++;
        } else {
          appendStr += suffix[i];
        }
      }
      if (zeroCounts + appendStr.length <= format) {
        return formatValue(
          `0.${'0'.repeat(zeroCounts)}${
            isUsd ? appendStr.substring(0, 2) : appendStr
          }`,
          format,
        );
      } else {
        if (zeroCounts < format - 2) {
          return `0.${'0'.repeat(zeroCounts)}${appendStr.substring(
            0,
            isUsd ? 2 : format - zeroCounts,
          )}`;
        } else {
          return (
            <div className="flex gap-[1px]">
              0.0
              <div className="scale-[0.7] origin-bottom mr-[-1%]">
                {zeroCounts}
              </div>
              {appendStr.substring(0, format - 2)}
            </div>
          );
        }
      }
    }
  }, [value, format]);
  return (
    <div className={clsx('tracking-thin flex items-center', className)}>
      {isUsd && '$'}
      {data}

      {symbol && ` ${symbol}`}
    </div>
  );
}
